import { Channel } from 'lib-shared-types-channels';
import { createContext } from 'react';

interface EditorCopilotDropdownContextProps {
  channel?: Channel;
}

export const EditorCopilotDropdownContext =
  createContext<EditorCopilotDropdownContextProps>({});
